import { createSlice, createAsyncThunk, PayloadAction } from '@reduxjs/toolkit'
import { fetchBenchmarkingChatResponse } from '../apis/chatApi'

interface Message {
    message: any;
    sender: 'user' | 'api';
    typing?: boolean;
    currentModule: string;
    response_type?: string;
    xaxis?: any;
    yaxis?: any;
}

interface ChatState {
    messages: Message[];
    status: 'idle' | 'loading' | 'succeeded' | 'failed';
    error: string | null;
    typingMessage: Message | null;
    history: any
}

const initialState: ChatState = {
    messages: [],
    status: 'idle',
    error: null,
    typingMessage: null,
    history: [],
}

interface ApiParams {
    msge: string;
    history: any;
}

export const fetchResponseBenchmarking = createAsyncThunk<string, ApiParams>(
    'chatBenchmarking/fetchResponseBenchmarking',
    async ({ msge, history }: ApiParams) => {
        const response = await fetchBenchmarkingChatResponse(msge, history);
        return response
    }
)

const chatSliceBenchmarking = createSlice({
    name: 'chatBenchmarking',
    initialState,
    reducers: {
        addMessageBenchmarking: (state, action: PayloadAction<Message>) => {
            if (action.payload.message !== '**loading**') {
                state.messages.push(action.payload)
            }
        },
        setTypingMessageBenchmarking: (state, action: PayloadAction<Message | null>) => {
            state.typingMessage = action.payload
        },
    },
    extraReducers: (builder) => {
        builder.addCase(fetchResponseBenchmarking.pending, (state) => {
            state.status = 'loading'
            state.typingMessage = { message: '**loading**', sender: 'api', typing: true, currentModule: 'benchmarking' }
        }).addCase(fetchResponseBenchmarking.rejected, (state, action) => {
            state.status = 'failed'
            state.error = action.error.message || null
        }).addCase(fetchResponseBenchmarking.fulfilled, (state, action: any) => {
            state.status = 'succeeded'
            state.typingMessage = null

            state.messages.push({ message: action.payload.results, sender: 'api', typing: false, currentModule: 'benchmarking', response_type: action.payload.response_type, 'xaxis': action.payload.xaxis, 'yaxis': action.payload.yaxis })
            state.history = action.payload.response_memory
        })

    }
})

export default chatSliceBenchmarking.reducer

export const { addMessageBenchmarking, setTypingMessageBenchmarking } = chatSliceBenchmarking.actions